export default require("content/lib/models/content").default({
  type: "assessment"
})
